// extracted by mini-css-extract-plugin
module.exports = {"frameContainer":"Frame_frameContainer__WN72_","frameBody":"Frame_frameBody__8XL7Q"};